import { render, staticRenderFns } from "./500.vue?vue&type=template&id=72bc5544&scoped=true"
import script from "./500.vue?vue&type=script&lang=js"
export * from "./500.vue?vue&type=script&lang=js"
import style0 from "./500.vue?vue&type=style&index=0&id=72bc5544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc5544",
  null
  
)

export default component.exports